import {
  GET_QUESTIONS_SECRETS,
  SET_QUESTIONS_SECRETS,
  SET_PASSWORD_RECOVERY_STEP,
  SUBMIT_PASSWORD_RECOVERY_STEP,
  SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS,
  SUBMIT_PASSWORD_RECOVERY_STEP_FAIL,
  PREVIOUS_PASSWORD_RECOVERY_STEP,
  SET_LOGIN_RECOVERY_STEP,
  SUBMIT_LOGIN_RECOVERY_STEP,
  SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS,
  SUBMIT_LOGIN_RECOVERY_STEP_FAIL,
  PREVIOUS_LOGIN_RECOVERY_STEP,
  SET_TOKEN_CREDENTIALS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_SECRET_QUESTION,
  CHANGE_SECRET_QUESTION_SUCCESS,
  CHANGE_SECRET_QUESTION_FAIL,
  ENABLE_NOTIFICATIONS,
  ENABLE_NOTIFICATIONS_FAIL,
  ENABLE_NOTIFICATIONS_SUCCESS,
} from 'store/credentials/constants';
import {
  ActionWithPayloadType,
  ActionWithoutPayloadType,
} from 'store/credentials/types';

const setQuestionsSecret = (payload: any): SetQuestionSecretData => ({
  type: SET_QUESTIONS_SECRETS,
  payload,
});
const getQuestionSecret = () => ({
  type: GET_QUESTIONS_SECRETS,
});
const setPasswordRecoveryStep = (
  payload: string,
): setPasswordRecoveryStepType => ({
  type: SET_PASSWORD_RECOVERY_STEP,
  payload: payload,
});
const submitPasswordRecoveryStep = (
  payload: any,
): SubmitPasswordRecoveryStepType => ({
  type: SUBMIT_PASSWORD_RECOVERY_STEP,
  payload: payload,
});
const submitPasswordRecoveryStepSuccess = (
  payload: any,
): SubmitPasswordRecoveryStepSuccessType => ({
  type: SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS,
  payload: payload,
});
const submitPasswordRecoveryStepFail = (
  payload: any,
): SubmitPasswordRecoveryStepFailType => ({
  type: SUBMIT_PASSWORD_RECOVERY_STEP_FAIL,
  payload: payload,
});
const previousPassswordRecoveryStep = (): PreviousPasswordRecoveryStepType => ({
  type: PREVIOUS_PASSWORD_RECOVERY_STEP,
});

const setToken = (token: string): SetTokenType => ({
  type: SET_TOKEN_CREDENTIALS,
  payload: token,
});

const setLoginRecoveryStep = (payload: string): setLoginRecoveryStepType => ({
  type: SET_LOGIN_RECOVERY_STEP,
  payload: payload,
});
const submitLoginRecoveryStep = (
  payload: any,
): SubmitLoginRecoveryStepType => ({
  type: SUBMIT_LOGIN_RECOVERY_STEP,
  payload: payload,
});
const submitLoginRecoveryStepSuccess = (
  payload: any,
): SubmitLoginRecoveryStepSuccessType => ({
  type: SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS,
  payload: payload,
});
const submitLoginRecoveryStepFail = (
  payload: any,
): SubmitLoginRecoveryStepFailType => ({
  type: SUBMIT_LOGIN_RECOVERY_STEP_FAIL,
  payload: payload,
});
const previousLoginRecoveryStep = (): PreviousLoginRecoveryStepType => ({
  type: PREVIOUS_LOGIN_RECOVERY_STEP,
});

const changePassword = (payload: any): ChangePasswordType => ({
  type: CHANGE_PASSWORD,
  payload: payload,
});

const changePasswordSuccess = (): ChangePasswordSuccessType => ({
  type: CHANGE_PASSWORD_SUCCESS,
});

const changePasswordFailed = (): ChangePasswordFailType => ({
  type: CHANGE_PASSWORD_FAIL,
});

const changeSecretQuestion = (payload: any): ChangeSecretQuestionType => ({
  type: CHANGE_SECRET_QUESTION,
  payload: payload,
});

const changeSecretQuestionSuccess = (): ChangeSecretQuestionSuccessType => ({
  type: CHANGE_SECRET_QUESTION_SUCCESS,
});

const changeSecretQuestionFailed = (): ChangeSecretQuestionFailType => ({
  type: CHANGE_SECRET_QUESTION_FAIL,
});

const enableNotifications = (payload: any): EnableNotificationsType => ({
  type: ENABLE_NOTIFICATIONS,
  payload: payload,
});
const enableNotificationsSuccess = (): EnableNotificationsSuccessType => ({
  type: ENABLE_NOTIFICATIONS_SUCCESS,
});
const enableNotificationsFail = (): EnableNotificationsFailType => ({
  type: ENABLE_NOTIFICATIONS_FAIL,
});

export type CredentialsActionType =
  | SetQuestionSecretData
  | GetQuestionSecretData
  | setPasswordRecoveryStepType
  | SubmitPasswordRecoveryStepType
  | SubmitPasswordRecoveryStepFailType
  | SubmitPasswordRecoveryStepSuccessType
  | PreviousPasswordRecoveryStepType
  | setLoginRecoveryStepType
  | SubmitLoginRecoveryStepType
  | SubmitLoginRecoveryStepSuccessType
  | SubmitLoginRecoveryStepFailType
  | PreviousLoginRecoveryStepType
  | SetTokenType
  | ChangePasswordType
  | ChangePasswordSuccessType
  | ChangePasswordFailType
  | ChangeSecretQuestionFailType
  | ChangeSecretQuestionSuccessType
  | ChangeSecretQuestionType
  | EnableNotificationsType
  | EnableNotificationsSuccessType
  | EnableNotificationsFailType;

type SetQuestionSecretData = ActionWithPayloadType<
  typeof SET_QUESTIONS_SECRETS,
  string
>;

type GetQuestionSecretData = ActionWithoutPayloadType<
  typeof GET_QUESTIONS_SECRETS
>;
type PreviousPasswordRecoveryStepType = ActionWithoutPayloadType<
  typeof PREVIOUS_PASSWORD_RECOVERY_STEP
>;

type SubmitPasswordRecoveryStepType = ActionWithPayloadType<
  typeof SUBMIT_PASSWORD_RECOVERY_STEP,
  any
>;
type SubmitPasswordRecoveryStepSuccessType = ActionWithPayloadType<
  typeof SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS,
  any
>;

type SubmitPasswordRecoveryStepFailType = ActionWithPayloadType<
  typeof SUBMIT_PASSWORD_RECOVERY_STEP_FAIL,
  any
>;

type setPasswordRecoveryStepType = ActionWithPayloadType<
  typeof SET_PASSWORD_RECOVERY_STEP,
  string
>;
type SetTokenType = ActionWithPayloadType<typeof SET_TOKEN_CREDENTIALS, string>;
type setLoginRecoveryStepType = ActionWithPayloadType<
  typeof SET_LOGIN_RECOVERY_STEP,
  string
>;
type SubmitLoginRecoveryStepType = ActionWithPayloadType<
  typeof SUBMIT_LOGIN_RECOVERY_STEP,
  any
>;
type SubmitLoginRecoveryStepSuccessType = ActionWithPayloadType<
  typeof SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS,
  any
>;
type SubmitLoginRecoveryStepFailType = ActionWithPayloadType<
  typeof SUBMIT_LOGIN_RECOVERY_STEP_FAIL,
  any
>;
type PreviousLoginRecoveryStepType = ActionWithoutPayloadType<
  typeof PREVIOUS_LOGIN_RECOVERY_STEP
>;

type ChangePasswordType = ActionWithPayloadType<typeof CHANGE_PASSWORD, any>;
type ChangePasswordSuccessType = ActionWithoutPayloadType<
  typeof CHANGE_PASSWORD_SUCCESS
>;
type ChangePasswordFailType = ActionWithoutPayloadType<
  typeof CHANGE_PASSWORD_FAIL
>;

type ChangeSecretQuestionType = ActionWithPayloadType<
  typeof CHANGE_SECRET_QUESTION,
  any
>;
type ChangeSecretQuestionSuccessType = ActionWithoutPayloadType<
  typeof CHANGE_SECRET_QUESTION_SUCCESS
>;
type ChangeSecretQuestionFailType = ActionWithoutPayloadType<
  typeof CHANGE_SECRET_QUESTION_FAIL
>;

type EnableNotificationsType = ActionWithPayloadType<
  typeof ENABLE_NOTIFICATIONS,
  any
>;
type EnableNotificationsSuccessType = ActionWithoutPayloadType<
  typeof ENABLE_NOTIFICATIONS_SUCCESS
>;
type EnableNotificationsFailType = ActionWithoutPayloadType<
  typeof ENABLE_NOTIFICATIONS_FAIL
>;

export {
  setQuestionsSecret,
  getQuestionSecret,
  setPasswordRecoveryStep,
  submitPasswordRecoveryStepFail,
  submitPasswordRecoveryStepSuccess,
  previousPassswordRecoveryStep,
  submitPasswordRecoveryStep,
  setLoginRecoveryStep,
  submitLoginRecoveryStep,
  submitLoginRecoveryStepSuccess,
  submitLoginRecoveryStepFail,
  previousLoginRecoveryStep,
  setToken,
  changePassword,
  changePasswordSuccess,
  changePasswordFailed,
  changeSecretQuestion,
  changeSecretQuestionSuccess,
  changeSecretQuestionFailed,
  enableNotifications,
  enableNotificationsSuccess,
  enableNotificationsFail,
};
